module.exports = __webpack_public_path__ + "static/media/how-soc-md-mk-2.016104a5.png";